import * as yup from 'yup'

import { ResourceModel } from '@modules/resource/resource.module'
import { AddressSchema, getFieldPresets } from '@modules/resource/fields'
import UserModel from './user.model'

// TODO: move address somewhere shared

const AdminModel = UserModel.extend({
	resourceKey: 'admin',
	toCSV: {
		singular: false,
		list: false,
	}
}, [
	{
		key: 'role',
		label: 'Role',
		type: 'select',
		defaultValue: 'consultant',
		fieldProps: {
			options: [
				{ label: 'Super Admin', value: 'superadmin' },
				{ label: 'Consultant', value: 'consultant' },
			]
		},
		validator: yup.string().oneOf(['superadmin', 'consultant'])
	},
	...getFieldPresets([
		'address',
		'mobile',
		'profileImage',
		'documents',
	])
]);

// TODO: remove window instances after development
window.AdminModel = AdminModel;

export default AdminModel;


// WEBPACK FOOTER //
// ./src/modules/user/models/admin.model.js